var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        { staticClass: "tile is-parent", class: { "box  ml-2": _vm.showBox } },
        [
          _c("article", { staticClass: "tile is-child is-parent" }, [
            _c("div", { staticClass: "columns mb-0" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "pt-3 is-flex is-justify-content-flex-end" },
                [
                  _c("div", { class: { disabled: _vm.value.quoteId } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-default p-round p-smooth is-size-7",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerIsCompany,
                              expression: "innerIsCompany",
                            },
                          ],
                          attrs: {
                            id: "chk-pretty-customer-type",
                            name: "chk-pretty-customer-type",
                            type: "radio",
                          },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.innerIsCompany, true),
                          },
                          on: {
                            change: function ($event) {
                              _vm.innerIsCompany = true
                            },
                          },
                        }),
                        _vm._m(1),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-default p-round p-smooth is-size-7",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerIsCompany,
                              expression: "innerIsCompany",
                            },
                          ],
                          attrs: {
                            id: "chk-pretty-customer-type",
                            name: "chk-pretty-customer-type",
                            type: "radio",
                          },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.innerIsCompany, false),
                          },
                          on: {
                            change: function ($event) {
                              _vm.innerIsCompany = false
                            },
                          },
                        }),
                        _vm._m(2),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "is-divider" }),
            _c("div", { staticClass: "tile is-ancestor" }, [
              _c("div", { staticClass: "tile" }, [
                _c("div", { staticClass: "tile is-parent is-half" }, [
                  _c(
                    "article",
                    {
                      staticClass: "tile is-child",
                      class: { disabled: _vm.value.quoteId },
                    },
                    [
                      _vm.innerIsCompany
                        ? _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-required-label" },
                              [_vm._v("Company Name")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.value.customerName,
                                    expression: "value.customerName",
                                  },
                                ],
                                staticClass: "input",
                                class: {
                                  "is-danger":
                                    _vm.$v.entity.customerName.$error,
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.value.customerName },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.value,
                                      "customerName",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm.$v.entity &&
                              !_vm.$v.entity.customerName.required
                                ? _c(
                                    "span",
                                    { staticClass: "help is-danger" },
                                    [_vm._v("Company Name is required")]
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _c("div", { staticClass: "field-body" }, [
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "label",
                                { staticClass: "label is-required-label" },
                                [_vm._v("First Name")]
                              ),
                              _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.value.firstname,
                                      expression: "value.firstname",
                                    },
                                  ],
                                  staticClass: "input",
                                  class: {
                                    "is-danger": _vm.$v.entity.firstname.$error,
                                  },
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.value.firstname },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.value,
                                        "firstname",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm.$v.entity &&
                                !_vm.$v.entity.firstname.required
                                  ? _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v("First Name is required")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _c("div", { staticClass: "field" }, [
                              _c(
                                "label",
                                { staticClass: "label is-required-label" },
                                [_vm._v("Last Name")]
                              ),
                              _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.value.lastname,
                                      expression: "value.lastname",
                                    },
                                  ],
                                  staticClass: "input",
                                  class: {
                                    "is-danger": _vm.$v.entity.lastname.$error,
                                  },
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.value.lastname },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.value,
                                        "lastname",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm.$v.entity &&
                                !_vm.$v.entity.lastname.required
                                  ? _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v("Last Name is required")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Phone No "),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.customerPhoneNo,
                                expression: "value.customerPhoneNo",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "text" },
                            domProps: { value: _vm.value.customerPhoneNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "customerPhoneNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Email "),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value.customerEmail,
                                expression: "value.customerEmail",
                              },
                            ],
                            staticClass: "input",
                            class: {
                              "is-danger": _vm.$v.entity.customerEmail.$error,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.value.customerEmail },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.value,
                                  "customerEmail",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-flex is-align-items-center" }, [
      _c("i", { staticClass: "icon mdi mdi-account-outline mdi-24px" }),
      _c("p", { staticClass: "modal-card-title pl-1" }, [_vm._v("Customer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Company")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("label", { staticClass: "is-size-7" }, [_vm._v("Individual")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }